import { Button, Input, Select, Space } from 'antd'
import Modal from 'antd/es/modal/Modal'
import React, { useEffect, useState } from 'react'
import {
  findReqCategory,
  getMenuSubCategoryList
} from '../../../Utility/Menu/category.util'

const AddModal = ({
  visible,
  menuType,
  addCb,
  onCancel,
  categoryList,
  menu
}: any) => {
  console.log(visible, menuType, categoryList, menu)
  const [category, setCategory] = useState('')
  const [subCategory, setSubCategory] = useState('')
  const [foodItem, setFoodItem] = useState('')
  const [showFoodInput, setshowFoodInput] = useState(false)
  const [showSubCategoryInput, setshowSubCategoryInput] = useState(false)
  const [categoryHasSub, setCategoryHasSub] = useState(false)
  const [subCategoryList, setSubCategoryList] = useState([
    { value: '', label: '' }
  ])
  useEffect(() => {
    menuType.key ? setDefaultValue('Category') : ''
    menuType.subKey ? setDefaultValue('Subcategory') : ''
  }, [menuType])

  // on close of modal
  const handleModalClose = () => {
    if (menuType.type === 'Category') {
      addCb({ type: menuType.type, category: category })
      setCategory('')
    } else if (menuType.type === 'SubCategory/FoodItem') {
      addCb({
        type: menuType.type,
        category: category,
        subCategory: subCategory,
        foodItem: foodItem
      })
      setCategory('')
      setSubCategory('')
      setFoodItem('')
      setDefault()
    } else if (menuType.type === 'FoodItem') {
      addCb({
        type: menuType.type,
        category: category,
        subCategory: subCategory,
        foodItem: foodItem
      })
      setCategory('')
      setSubCategory('')
      setFoodItem('')
      setDefault()
    }
  }

  const getSubCategory = (e: any) => {
    console.log(e)
    setCategory(e)
    setSubCategoryList(getMenuSubCategoryList(menu, e))
  }

  const onClose = async () => {
    setCategory('')
    setFoodItem('')
    setSubCategory('')
    setDefault()
    onCancel()
  }

  const setDefaultValue = (type: string) => {
    if (type === 'Category') {
      console.log('yo')
      setCategory(menuType.key)
      const reqCategory = findReqCategory(menu, menuType.key)
      // console.log(reqCategory)
      setCategoryHasSub(reqCategory.hasSubCategory)
    } else if (type === 'Subcategory') {
      // console.log('yo2')
      setSubCategoryList(getMenuSubCategoryList(menu, menuType.key))
      setSubCategory(menuType.subKey)
    }
  }

  const addSubCategory = () => {
    setshowFoodInput(false)
    setshowSubCategoryInput(true)
  }
  const addFoodItem = () => {
    setshowFoodInput(true)
    setshowSubCategoryInput(false)
  }
  const setDefault = () => {
    setshowFoodInput(false)
    setshowSubCategoryInput(false)
  }

  return (
    <Modal
      title={`Enter ${menuType.type} name`}
      centered
      open={visible}
      footer={
        <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
          <Button type='primary' onClick={() => handleModalClose()}>
            OK
          </Button>
          <Button onClick={onClose}>Cancel</Button>
        </div>
      }
      style={{ textAlign: 'center', width: '100%' }}
    >
      {menuType.type === 'Category' && (
        <Input
          onChange={(e) => setCategory(e.target.value)}
          className='category'
          placeholder='Enter Category Name'
          size='large'
          value={category}
        />
      )}
      {menuType.type === 'SubCategory/FoodItem' && (
        <>
          <Space direction='vertical' style={{ width: '100%' }} size='large'>
            <Select
              showSearch
              placeholder='Select a Category'
              filterOption={(input, option) =>
                ((option?.label as string) ?? '')
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              options={categoryList}
              onSelect={(e) => setCategory(e)}
              value={category}
              disabled={true}
              size='large'
              style={{ width: '200px' }}
            />
            <div
              style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}
            >
              <Button
                disabled={
                  !categoryHasSub &&
                  menu.find((item: any) => {
                    console.log(item, menuType)
                    return item.category_id === menuType.key
                  }).children.length > 0
                }
                onClick={addSubCategory}
              >
                Add SubCategory
              </Button>
              <Button disabled={categoryHasSub} onClick={addFoodItem}>
                Add Food Item
              </Button>
            </div>

            {showSubCategoryInput && (
              <Input
                onChange={(e) => setSubCategory(e.target.value)}
                className='subCategory'
                placeholder='Enter SubCategory Name'
                size='large'
                value={subCategory}
                // disabled={category ? false : true}
              />
            )}
            {showFoodInput && (
              <Input
                onChange={(e) => setFoodItem(e.target.value)}
                className='subCategory'
                placeholder='Enter Food item name'
                size='large'
                value={foodItem}
                // disabled={subCategory ? false : true}
              />
            )}
          </Space>
        </>
      )}
      {menuType.type === 'FoodItem' && (
        <>
          <Space direction='vertical' style={{ width: '100%' }} size='large'>
            <Select
              showSearch
              placeholder='Select the Category'
              filterOption={(input, option) =>
                ((option?.label as string) ?? '')
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              size='large'
              options={categoryList}
              onSelect={(e) => getSubCategory(e)}
              value={category}
              style={{ width: '200px' }}
              disabled={true}
            />
            <Select
              showSearch
              placeholder='Select the SubCategory'
              filterOption={(input, option) =>
                ((option?.label as string) ?? '')
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              options={subCategoryList}
              onSelect={(e) => setSubCategory(e)}
              value={subCategory}
              style={{ width: '200px' }}
              size='large'
              disabled={true}
            />
            <Input
              onChange={(e) => setFoodItem(e.target.value)}
              className='subCategory'
              placeholder='Enter Food item name'
              size='large'
              value={foodItem}
              // disabled={subCategory ? false : true}
            />
          </Space>
        </>
      )}
    </Modal>
  )
}

export default AddModal
